import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsGeneralParams from "../../../src/SubTabsGeneralParams";
import { isSuperAdmin } from "./../../helpers/user.js";
import axiosService from '../../helpers/axios';


  export default class GeneralParamsSuppliers extends Component{ 

    constructor(props){
      super(props);

      this.state={
          suppliers:[],
          modalTitle:"",
          suppliername:"",
          supplierid:0,
          suppliershortname:"",
          country: {
            countryname: "",
            countryid:0
            },
          isactive:true,

          SupplierIdFilter:"",
          SupplierNameFilter:"",
          SupplierShortNameFilter:"",
          CountryNameFilter:"",
          IsactiveFilter:"",
          CountryIdFilter:"",
          suppliersWithoutFilter:[],
          countryNames: [],        // Holds the list of country names
          supplierNames: [],
          supplierShortNames: [],
          supplierExists: false,
          supplierShortNameExists: false,
          uniqueSupplierIdsProducts:[],
          
        
      }
  }

  FilterFn(){
    var SupplierIdFilter=this.state.SupplierIdFilter;
    var SupplierNameFilter = this.state.SupplierNameFilter;
    var SupplierShortNameFilter = this.state.SupplierShortNameFilter;
    var CountryNameFilter = this.state.CountryNameFilter;
    var CountryIdFilter = this.state.CountryIdFilter;
    var IsactiveFilter = this.state.IsactiveFilter;

    var filteredData=this.state.suppliersWithoutFilter.filter(
        function(el){
            return el.supplierid.toString().toLowerCase().includes(
                SupplierIdFilter.toString().trim().toLowerCase()
            )&&
            el.suppliername.toString().toLowerCase().includes(
                SupplierNameFilter.toString().trim().toLowerCase()
            )&&
            el.country.countryname.toString().toLowerCase().includes(
                CountryNameFilter.toString().trim().toLowerCase()
            )&&
            el.country.countryid.toString().toLowerCase().includes(
                CountryIdFilter.toString().trim().toLowerCase()
            )&&
            el.isactive.toString().toLowerCase().includes(
                IsactiveFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({suppliers:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.suppliersWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({suppliers:sortedData});

}

changeSupplierIdFilter = (e)=>{
  this.state.SupplierIdFilter=e.target.value;
  this.FilterFn();
}
changeSupplierNameFilter = (e)=>{
  this.state.SupplierNameFilter=e.target.value;
  this.FilterFn();
}


changeSupplierShortNameFilter = (e)=>{
  this.state.SupplierShortNameFilter=e.target.value;
  this.FilterFn();
}


changeCountryNameFilter = (e)=>{
  this.state.CountryNameFilter=e.target.value;
  this.FilterFn();
}

changeCountryIdFilter = (e)=>{
  this.state.CountryIdFilter=e.target.value;
  this.FilterFn();
}

changeIsActiveFilter = (e)=>{
  this.state.IsactiveFilter=e.target.value;
  this.FilterFn();
}



refreshList(){
  axiosService.get('/suppliers/')
  .then(response=>{
      const data = response.data?.results ?? response.data;
      this.setState({suppliers:data,suppliersWithoutFilter:data});
  });
}

fetchCountryNames() {
  axiosService.get('/countrynames/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const countryNames = filteredData.map(item => item.countryname);
      this.setState({ countryNames: countryNames });
    })
    .catch(error => {
      console.error("Error fetching country names:", error);
    });
}


fetchSupplierNames() {
  axiosService.get('/suppliers/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const supplierNames = data.map(item => item.suppliername);
      this.setState({ supplierNames: supplierNames });
    })
    .catch(error => {
      console.error("Error fetching supplier names:", error);
    });
}

fetchSupplierShortNames() {
  axiosService.get('/suppliers/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const supplierShortNames = data.map(item => item.suppliershortname);
      this.setState({ supplierShortNames: supplierShortNames });
    })
    .catch(error => {
      console.error("Error fetching supplierShort names:", error);
    });
}

fetchSupplierIdsProducts() {
  axiosService.get('/defaultproductscreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueSupplierIdsProducts = [...new Set(data.map((item) => item.currencyid))];
      this.setState({ uniqueSupplierIdsProducts: uniqueSupplierIdsProducts });
    })
    .catch((error) => {
      console.error('Error fetching suppliers data:', error);
    });
}

fetchSupplierIdsProducts2() {
  axiosService.get('/purchasescreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      // Filter the data where purchasetypeid is equal to 1
      const filteredData = data.filter((item) => item.purchasetypeid === 2);

      // Extract unique warehouseid values from the filtered data
      const uniqueSupplierIdsProducts = [...new Set(filteredData.map((item) => item.itempurchasedid_id))];

      this.setState({ uniqueSupplierIdsProducts: uniqueSupplierIdsProducts });
    })
    .catch((error) => {
      console.error('Error fetching suppliers data:', error);
    });
}



checkSupplierExists = (event) => {
  const enteredSupplier = event.target.value.toLowerCase(); // Convert to lowercase
  const { supplierNames } = this.state;
  const supplierExists = supplierNames.some((supplier) => supplier.toLowerCase() === enteredSupplier);
  this.setState({ supplierExists });
};

checkSupplierShortNameExists = (event) => {
  const enteredSupplierShortName = event.target.value.toLowerCase(); // Convert to lowercase
  const { supplierShortNames } = this.state;
  const supplierShortNameExists = supplierShortNames.some((suppliershortname) => suppliershortname.toLowerCase() === enteredSupplierShortName);
  this.setState({ supplierShortNameExists });
};


componentDidMount(){
  this.refreshList();
  this.fetchCountryNames();
  this.fetchSupplierNames();
  this.fetchSupplierShortNames();
  this.fetchSupplierIdsProducts();
}

changeSupplierName =(e)=>{
  this.setState({suppliername:e.target.value});
}

changeSupplierShortName =(e)=>{
  this.setState({suppliershortname:e.target.value});
}


changeCountryName =(e)=>{
  this.setState({countryname:e.target.value});
}

changeCountryId =(e)=>{
  this.setState({countryid:e.target.value});
}

changeIsActive = (event) => {
  const isChecked = event.target.checked;
  this.setState({ isactive: isChecked });
};


resetSelect = () => {
  setTimeout(() => {
    this.setState({ selectedCountry: this.state.countryname });
  }, 0);
};

addClick(){
  this.resetSelect();
  this.setState({
      modalTitle:"Add Supplier",
      supplierid:0,
      suppliername: "",
      suppliershortname: "",
      countryname:"",
      isactive: true,
      countryid:0,
      supplierExists: false,
      supplierShortNameExists: false,
  });
}
editClick(dep){
  this.resetSelect();
  this.setState({
      modalTitle:"Edit Supplier",
      supplierid:dep.supplierid,
      suppliername:dep.suppliername,
      suppliershortname:dep.suppliershortname,
      countryname:dep.country.countryname,
      countryid:dep.country.countryid,
      isactive: dep.isactive,
      initialSuppliername: dep.suppliername,
      initialSuppliershortname: dep.suppliershortname,
      initialCountryname: dep.country.countryname,
      initialIsactive: dep.isactive,
      supplierExists: false,
      supplierShortNameExists: false,
  });
}

createClick() {
  const { suppliername, suppliershortname, countryname ,isactive, supplierNames, supplierShortNames} = this.state;

  if (!suppliername) {
    alert('Supplier Name is required');
    return;
  }

  if (supplierNames.some(name => name.toLowerCase() === suppliername.toLowerCase())) {
    alert('Supplier already exists. Please provide a unique Supplier Name.');
    return;
  }
  

  if (supplierShortNames.some(name => name.toLowerCase() === suppliershortname.toLowerCase())) {
    alert('Supplier ShortName already exists. Please provide a unique Supplier ShortName.');
    return;
  }
  
  if (!countryname) {
    alert('Country is required');
    return;
  }

  axiosService.post('/supplierscreate/', {
    suppliername: suppliername,
    suppliershortname: suppliershortname,
    countryname:countryname,
    isactive: isactive
  })
    .then(result => {
      alert('Supplier created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}

updateClick(id) {

  const { suppliername, suppliershortname, countryname, isactive, initialSuppliername, initialSuppliershortname, initialCountryname, initialIsactive, supplierNames, supplierShortNames } = this.state;

   // Check if any changes are detected
   if (
    suppliername === initialSuppliername &&
    suppliershortname === initialSuppliershortname &&
    countryname === initialCountryname &&
    isactive === initialIsactive
  ) {
    alert('No changes detected');
    return;
  }

  if (
    supplierNames.some((existingSupplier) => existingSupplier.toLowerCase() === suppliername.toLowerCase() && suppliername !== initialSuppliername
    )
  ) {
    this.setState({ suppliername: initialSuppliername });
    return;
  }
  

  if (
    supplierShortNames.some((existingShortName) => existingShortName.toLowerCase() === suppliershortname.toLowerCase() && suppliershortname !== initialSuppliershortname
    )
  ) {
    this.setState({ suppliershortname: initialSuppliershortname });
    return;
  }

  if (!countryname) {
    alert('Country is required');
    return;
  }
  

  axiosService.patch('/suppliers/' + id + '/', {
    supplierid: this.state.supplierid,
    suppliershortname: this.state.suppliershortname,
    suppliername:this.state.suppliername,
    countryname: this.state.countryname,
    isactive: this.state.isactive
  })
    .then((result) => {
      alert('Update successful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch((error) => {
      alert('Failed');
    });
}


deleteClick(id) {
   // Check if the id is in the array
   if (this.state.uniqueSupplierIdsProducts.includes(id)) {
    alert('Cannot delete this Supplier as it is in the Products Table !');
    return; // Exit the function without making the delete request
  }
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/suppliers/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        window.location.reload(); // Refresh the page
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      suppliers,
      modalTitle,
      supplierid,
      suppliername,
      suppliershortname,
      countryname,
      isactive,
      countryid,
      countries,
      supplierExists,
      supplierShortNameExists
  }=this.state;

  return(
<div className="scrollable-container">
<MyPage />
<SubTabsGeneralParams />
<button type="button"
disabled={!isSuperAdmin()}
className="btn btn-primary m-2 float-end"
data-bs-toggle="modal"
data-bs-target="#exampleModal"
onClick={()=>this.addClick()}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>
  Add Supplier
</button>
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
       style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeSupplierIdFilter}
      placeholder="Filter"/>
      

      </div>
      SupplierId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "200px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeSupplierNameFilter}
      placeholder="Filter"/>
      </div>
      SupplierName
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      SupplierShortname
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "200px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeCountryNameFilter}
      placeholder="Filter"/>

      </div>
      Country
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeIsActiveFilter}
      placeholder="Filter"/>
      </div>
      Is Active
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
<tbody>
  {suppliers.map(dep=>
      <tr key={dep.supplierid} className="row-hover">
          <td className="table-text">{dep.supplierid}</td>
          <td className="table-text">{dep.suppliername}</td>
          <td className="table-text">{dep.suppliershortname}</td>
          <td className="table-text">{dep.country.countryname}</td>
          <td className="table-text">{dep.isactive.toString()}</td>
          <td className="table-text">
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          onClick={()=>this.deleteClick(dep.supplierid)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
          </button>

          </td>
      </tr>
      )}
</tbody>
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Supplier Name</span>
          <input
            type="text"
            className={`form-control ${supplierExists ? "is-invalid" : ""}`}
            value={suppliername}
            onChange={this.changeSupplierName}
            onBlur={this.checkSupplierExists} 
            style={{ fontSize: "12px" }} 
          />
          {supplierExists && <div className="invalid-feedback" style={{ fontSize: "12px" }} >Supplier already exists.</div>}
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >SupplierShortName</span>
          <input
            type="text"
            className={`form-control ${supplierShortNameExists ? "is-invalid" : ""}`}
            value={suppliershortname}
            onChange={this.changeSupplierShortName}
            onBlur={this.checkSupplierShortNameExists} 
            style={{ fontSize: "12px" }} 
          />
          {supplierShortNameExists && <div className="invalid-feedback" style={{ fontSize: "12px" }} >Supplier Shortname already exists.</div>}
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Country</span>
          <select
            className="form-select"
            value={this.state.countryname}
            onChange={(event) => this.setState({ countryname: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a country</option>
            {this.state.countryNames.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Isactive</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={isactive}
            onChange={this.changeIsActive}
          />
        </div>

        {supplierid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {supplierid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.updateClick(supplierid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>
</div>
  )
}
}

